import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3333 14L12 23.6H16.8L20 18.2667H26.4L29.0667 14H17.3333Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8 24.6667H12L17.3333 34.2667H23.7333L36 14H30.6667L20.5333 30L16.8 24.6667Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9333 30.5333L24.8 34.2667H29.6L26.9333 30.5333Z",
			fill: "black"
		})
	]
});
export default SvgCrsIcon;
